import { render } from "./MyFAQ.vue?vue&type=template&id=21b6e0df"
import script from "./MyFAQ.vue?vue&type=script&lang=js"
export * from "./MyFAQ.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__